import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class EventService {
  eventHandler: Subject<any>;

  constructor() {
    this.eventHandler = new Subject<any>();
  }
  broadcast(eventName: string, data?: any) {
    this.eventHandler.next({ eventName, data });
  }
  on(eventName: string, callback: any) {
    this.eventHandler.pipe(
      filter((event) => {
        return event.eventName === eventName;
      })
    ).subscribe(callback);
  }
}